import { Color3 } from "@babylonjs/core/Maths/math.color";
import { DynamicTexture } from "@babylonjs/core/Materials/Textures/dynamicTexture";
import { CreatePlane } from "@babylonjs/core/Meshes/Builders/planeBuilder";
import { StandardMaterial } from '@babylonjs/core/Materials/standardMaterial';
import { Texture as BJSTexture } from "@babylonjs/core/Materials/Textures/texture";
import { PI_DIV2 } from "@egr/wcf/modules/utils/math";
import { StringProperty, PropertyValue, PropertyChangedResult, LengthProperty, NumberProperty, Color3Property } from "@egr/wcf/modules/core/prop";
import { ShadowGenerator } from "@egr/wcf/modules/core/rendering/ShadowGenerator";
import { ElementGeometry } from "./ElementGeometry";
import { Util } from "../../utils/Util";
export class Text extends ElementGeometry {
    constructor(pRoomManager, pElement) {
        super(pRoomManager, pElement);
        this.mRoomElement = pElement;
        this.mRoomManager = pRoomManager;
        this.mFontSize = 48;
        this.mFont = this.mRoomManager.app.theme.fontFamily;
        this.mPickPlane = null;
        this.mzBegin = 0;
        this.mRoomElement.setObjectType("TextObject");
    }
    getType() {
        return ("Text");
    }
    setMesh(pMesh) {
        //
    }
    showInteractors(pShow) {
        if (this.mInteractors != null)
            this.mInteractors.showInteractors(pShow);
    }
    getInitialParams() {
        let tParams = {};
        tParams.width = 0.5;
        tParams.height = 0.001;
        tParams.floorOffset = 0.0;
        tParams.color = "#ffffff";
        tParams.text = "Text";
        tParams.textColor = "#000000";
        tParams.textScale = 0.5;
        return (tParams);
    }
    create2dGeometry(pParent) {
        this.filterTextLines(pParent, 1);
        //this.createText(pParent, 1);
        this.createPickPlane(pParent);
    }
    create3dGeometry(pParent) {
        this.filterTextLines(pParent, 0);
        //this.createText(pParent, 0);
    }
    getProperties() {
        let tProperties = new Array();
        //text
        let tTextProp = new StringProperty(this.mRoomElement, Text.PROP_KEY_TEXT, this.mRoomManager.resources.propertyText);
        tTextProp.getValue = () => new PropertyValue(this.mRoomElement.text);
        tTextProp.setValue = (pValue) => {
            let tValue = StringProperty.ConvertValueToString(pValue);
            if (tValue != null && this.mRoomElement.setText(tValue))
                return (Promise.resolve(PropertyChangedResult.Value));
            return (Promise.resolve(PropertyChangedResult.Nothing));
        };
        tProperties.push(tTextProp);
        //text scale
        let tTextScaleProp = new LengthProperty(this.mRoomElement, Text.PROP_KEY_TEXTHEIGHT, this.mRoomManager.resources.propertyTextHeight);
        tTextScaleProp.minValue = 0.01;
        tTextScaleProp.maxValue = 20;
        tTextScaleProp.numDecDigits = 0;
        tTextScaleProp.getValue = () => new PropertyValue(this.mRoomElement.textHeight);
        tTextScaleProp.setValue = (pValue) => {
            let tValue = NumberProperty.ConvertValueToNumber(pValue);
            if (tValue != null && this.mRoomElement.setTextHeight(tValue))
                return (Promise.resolve(PropertyChangedResult.Value));
            return (Promise.resolve(PropertyChangedResult.Nothing));
        };
        tProperties.push(tTextScaleProp);
        let tColorChoices = new Array();
        for (let tCol of this.mRoomManager._textColors)
            tColorChoices.push(this.mRoomManager._getTextColorPropValue(tCol));
        //text color
        let tTextColorProp = new Color3Property(this.mRoomElement, Text.PROP_KEY_TEXTCOLOR, this.mRoomManager.resources.propertyColor);
        tTextColorProp.choiceList = true;
        tTextColorProp.getChoices = () => Promise.resolve(tColorChoices);
        tTextColorProp.getValue = () => this.mRoomManager._getTextColorPropValue(this.mRoomElement.textColor, true);
        tTextColorProp.setValue = (pValue) => {
            let tValue = StringProperty.ConvertValueToString(pValue);
            if (tValue != null && this.mRoomElement.setTextColor(tValue))
                return (Promise.resolve(PropertyChangedResult.Value));
            return (Promise.resolve(PropertyChangedResult.Nothing));
        };
        tProperties.push(tTextColorProp);
        return (tProperties);
    }
    getEOXDescription(pDocument, pParentNode) {
        let tAttribsList = new Array();
        tAttribsList = [];
        tAttribsList.push({ qualifiedName: "structure_type", value: "Text" });
        let tRoomElementNode = Util._xmlAddChildNode(pDocument, pParentNode, "object", "", tAttribsList);
        // define category
        Util._xmlAddChildNode(pDocument, tRoomElementNode, "category", "Other", null);
        // position
        tAttribsList = [];
        tAttribsList.push({ qualifiedName: "x", value: this.mRoomElement.position.x.toString() });
        tAttribsList.push({ qualifiedName: "y", value: (-this.mRoomElement.position.y).toString() });
        tAttribsList.push({ qualifiedName: "z", value: (this.mRoomElement.position.z).toString() });
        Util._xmlAddChildNode(pDocument, tRoomElementNode, "position", "", tAttribsList);
        // rotation
        let t3dRotation = this.mRoomElement.node.rotationQuaternion;
        tAttribsList = [];
        if (t3dRotation != null) {
            tAttribsList.push({ qualifiedName: "x", value: (-t3dRotation.x).toString() });
            tAttribsList.push({ qualifiedName: "y", value: (-t3dRotation.z).toString() });
            tAttribsList.push({ qualifiedName: "z", value: (-t3dRotation.y).toString() });
            tAttribsList.push({ qualifiedName: "w", value: (-t3dRotation.w).toString() });
            Util._xmlAddChildNode(pDocument, tRoomElementNode, "rotation", "", tAttribsList);
        }
        else {
            tAttribsList.push({ qualifiedName: "x", value: "0" });
            tAttribsList.push({ qualifiedName: "y", value: "0" });
            tAttribsList.push({ qualifiedName: "z", value: "0" });
            tAttribsList.push({ qualifiedName: "w", value: "1" });
            Util._xmlAddChildNode(pDocument, tRoomElementNode, "rotation", "", tAttribsList);
        }
        // width
        Util._xmlAddChildNode(pDocument, tRoomElementNode, "width", this.mRoomElement.width.toString(), null);
        // height
        Util._xmlAddChildNode(pDocument, tRoomElementNode, "height", this.mRoomElement.depth.toString(), null);
        // text
        Util._xmlAddChildNode(pDocument, tRoomElementNode, "text", this.mRoomElement.text, null);
        // color
        tAttribsList = [];
        let tcolor = Util.hexToRGB(this.mRoomElement.textColor);
        tAttribsList.push({ qualifiedName: "r", value: tcolor.r.toString() });
        tAttribsList.push({ qualifiedName: "g", value: tcolor.g.toString() });
        tAttribsList.push({ qualifiedName: "b", value: tcolor.b.toString() });
        Util._xmlAddChildNode(pDocument, tRoomElementNode, "color", "", tAttribsList);
    }
    setPickPlane(pEnabled) {
        if (this.mPickPlane != null)
            this.mPickPlane.setEnabled(pEnabled);
    }
    getMaxMeasureFromText(pText) {
        let tevalTexture = new DynamicTexture("dynamic texture", 64, null, true);
        let ttexContext = tevalTexture.getContext();
        ttexContext.font = this.mFontSize + "px " + this.mFont;
        let tLines = pText.split("\n");
        let tTxtMeasure = {};
        tTxtMeasure.lines = new Array();
        tTxtMeasure.maxWidth = 0;
        tTxtMeasure.lineCount = tLines.length;
        for (let n = 0; n < tLines.length; n++) {
            tLines[n] = tLines[n].substring(0, 100);
            tTxtMeasure.lines.push(tLines[n]);
            let tMetrics = ttexContext.measureText(tLines[n]);
            tTxtMeasure.maxWidth = Math.max(tTxtMeasure.maxWidth, tMetrics.width);
        }
        return (tTxtMeasure);
    }
    filterTextLines(pParent, pRenderingGroupId) {
        let tTextMeasure = this.getMaxMeasureFromText(this.mRoomElement.text);
        let ttextMaxWidth = tTextMeasure.maxWidth;
        let ttextLineCount = tTextMeasure.lineCount;
        let tElementSize = this.getElementSize(tTextMeasure);
        this.mRoomElement.setDepth(tElementSize.depth, false);
        this.mRoomElement.setWidth(tElementSize.width, false);
        for (let i = 0; i < ttextLineCount; i++) {
            this.createText(pParent, tTextMeasure.lines[i], pRenderingGroupId, i);
        }
    }
    getElementSize(pTextData) {
        let tRes = {};
        let ttextMaxWidth = pTextData.maxWidth;
        let ttextLineCount = pTextData.lineCount;
        let tFont = this.mFontSize + "px " + this.mFont;
        let tTextHeight = this.mRoomElement.textHeight;
        let tdynTextureHeight = 1.3 * this.mFontSize;
        let tRatio = (tTextHeight / tdynTextureHeight);
        tRes.width = 0;
        tRes.depth = this.mRoomElement.textHeight * ttextLineCount;
        for (let i = 0; i < ttextLineCount; i++) {
            let ttmpDynTexture = new DynamicTexture("dynamic texture", 64, null, true);
            let ttmpDynTextureContext = ttmpDynTexture.getContext();
            ttmpDynTextureContext.font = tFont;
            let tdynTextureWidth = ttmpDynTextureContext.measureText(pTextData.lines[i]).width + 8;
            // calc width the plane has to be
            tRes.width = Math.max(tRes.width, tdynTextureWidth * tRatio);
        }
        let tDH = tRes.depth * 0.5;
        let tTH = this.mRoomElement.textHeight * 0.5;
        this.mzBegin = tDH - tTH;
        return (tRes);
    }
    createText(pParent, pText, pRenderingGroupId, pIndex) {
        let tFont = this.mFontSize + "px " + this.mFont;
        let tTextHeight = this.mRoomElement.textHeight;
        let tdynTextureHeight = 1.28 * this.mFontSize;
        let tRE_HW = this.mRoomElement.width * 0.5;
        // calc ratio
        let tRatio = (tTextHeight / tdynTextureHeight);
        let ttmpDynTexture = new DynamicTexture("dynamic texture", 64, null, true);
        let ttmpDynTextureContext = ttmpDynTexture.getContext();
        ttmpDynTextureContext.font = tFont;
        let tdynTextureWidth = ttmpDynTextureContext.measureText(pText).width + 8;
        // calc width the plane has to be
        let tTextWidth = tdynTextureWidth * tRatio;
        let tTextOffset = 98;
        if (this.mRoomElement.textHeight <= 20)
            tTextOffset = 98;
        if (this.mRoomElement.textHeight <= 10)
            tTextOffset = 98;
        if (this.mRoomElement.textHeight <= 1)
            tTextOffset = 98;
        tTextOffset = this.mFontSize - 2;
        // dynamic texture with text
        let tdynTexture = new DynamicTexture("room:RoomElement:TextDynamicTexture", { width: tdynTextureWidth, height: tdynTextureHeight }, this.mScene, false, BJSTexture.TRILINEAR_SAMPLINGMODE);
        let tMaterial = new StandardMaterial("room:text_material", this.mScene);
        tMaterial.disableLighting = true;
        tMaterial.specularColor = Color3.FromHexString(this.mRoomElement.textColor);
        tMaterial.emissiveColor = Color3.FromHexString(this.mRoomElement.textColor);
        tMaterial.diffuseTexture = tdynTexture;
        tMaterial.specularTexture = tdynTexture;
        tMaterial.backFaceCulling = false;
        tdynTexture.drawText(pText, null, tTextOffset, tFont, this.mRoomElement.textColor, "transparent", true);
        tdynTexture.hasAlpha = true;
        let tplane_HW = tTextWidth * 0.5;
        let txBegin = -(tRE_HW - tplane_HW);
        // creat plane and set dynamic texture as material
        let toutputPlane = CreatePlane("room:RoomElement:TextPlane", { width: tTextWidth, height: tTextHeight * 1.1 }, this.mScene);
        toutputPlane.rotation.x = Math.PI / 2;
        toutputPlane.position.z = this.mzBegin - tTextHeight * pIndex;
        toutputPlane.position.x = txBegin;
        toutputPlane.material = tMaterial;
        toutputPlane.renderingGroupId = pRenderingGroupId;
        toutputPlane.isPickable = true;
        ShadowGenerator.disableMeshShadow(toutputPlane);
        toutputPlane.scaling.x = 1;
        toutputPlane.scaling.y = 1;
        toutputPlane.parent = pParent;
    }
    createPickPlane(pParent) {
        //invisible geometry for picking
        this.mPickPlane = CreatePlane("room:RoomElement:TextPickPlane", {
            width: this.mRoomElement.width,
            height: this.mRoomElement.depth
        }, this.mScene);
        this.mPickPlane.position.y = 10;
        this.mPickPlane.rotation.x = PI_DIV2;
        this.mPickPlane.parent = pParent;
        this.mPickPlane.isPickable = true;
        this.mPickPlane.visibility = 0.0;
        if (this.mRoomManager.viewMode == 0) {
            this.mPickPlane.setEnabled(true);
        }
        else {
            this.mPickPlane.setEnabled(false);
        }
    }
}
//// private ///////////////////////////////////////////////////////////////////////////////
Text.PROP_KEY_TEXT = "room:RoomElement:text";
Text.PROP_KEY_TEXTCOLOR = "room:RoomElement:textcolor";
Text.PROP_KEY_TEXTHEIGHT = "room:RoomElement:textheight";
